import type { AtAGlanceProps } from "./types";

export default function AtAGlance({ headingId, heading, intro, rows }: AtAGlanceProps) {
  return (
    <section className="py-section-sm border-border border-b" aria-labelledby={headingId}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="border-border bg-muted/20 rounded-2xl border p-6 sm:p-8">
          <h2
            id={headingId}
            className="text-foreground mb-3 text-xl font-bold tracking-tight sm:text-2xl"
          >
            {heading}
          </h2>
          <p className="text-muted-foreground mb-6 max-w-3xl text-base leading-relaxed">{intro}</p>
          <dl className="grid grid-cols-1 gap-x-8 gap-y-4 sm:grid-cols-2 lg:grid-cols-4">
            {rows.map((row) => (
              <div key={row.label} className="border-border/60 border-t pt-3">
                <dt className="text-muted-foreground text-xs font-semibold tracking-wide uppercase">
                  {row.label}
                </dt>
                <dd className="text-foreground mt-1 text-sm font-medium">{row.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}
